// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="date"]::-webkit-calendar-picker-indicator {
    font-size: 24px;
    margin-right: 20px;
}

input[type="date"] {
    /* -webkit-appearance: none; Remove default appearance */
    /* appearance: none; */
    padding: 8px; /* Adjust padding as needed */
    font-size: 16px; /* Adjust font size as needed */
}

input[type="text"] {
    /* -webkit-appearance: none; Remove default appearance */
    /* appearance: none; */
    padding: 8px; /* Adjust padding as needed */
    font-size: 16px; /* Adjust font size as needed */
}

input[type="number"] {
    /* -webkit-appearance: none; Remove default appearance */
    /* appearance: none; */
    padding: 8px; /* Adjust padding as needed */
    font-size: 16px; /* Adjust font size as needed */
}

.placeholder{
    padding: 8px; /* Adjust padding as needed */
    font-size: 16px; /* Adjust font size as needed */
}
/* .dateinput::placeholder{
    color:'red'
} */

input:focus {
    outline:1px solid #007bff; /* Remove default outline */
    border-color: #00bfff; /* Change the border color on focus */
    /* Add any additional styles you want for the focused state */
}

.descriptionInput{
    padding: 8px; /* Adjust padding as needed */
    font-size: 16px; /* Adjust font size as needed */
}

.descriptionInput:focus{
    outline:1px solid #007bff; /* Remove default outline */
    border-color: #00bfff; /* Change the border color on focus */
}`, "",{"version":3,"sources":["webpack://./src/AdminPages/Video/Addvideo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wDAAwD;IACxD,sBAAsB;IACtB,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,+BAA+B;AACpD;;AAEA;IACI,wDAAwD;IACxD,sBAAsB;IACtB,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,+BAA+B;AACpD;;AAEA;IACI,wDAAwD;IACxD,sBAAsB;IACtB,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,+BAA+B;AACpD;;AAEA;IACI,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,+BAA+B;AACpD;AACA;;GAEG;;AAEH;IACI,yBAAyB,EAAE,2BAA2B;IACtD,qBAAqB,EAAE,qCAAqC;IAC5D,6DAA6D;AACjE;;AAEA;IACI,YAAY,EAAE,6BAA6B;IAC3C,eAAe,EAAE,+BAA+B;AACpD;;AAEA;IACI,yBAAyB,EAAE,2BAA2B;IACtD,qBAAqB,EAAE,qCAAqC;AAChE","sourcesContent":["input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    font-size: 24px;\n    margin-right: 20px;\n}\n\ninput[type=\"date\"] {\n    /* -webkit-appearance: none; Remove default appearance */\n    /* appearance: none; */\n    padding: 8px; /* Adjust padding as needed */\n    font-size: 16px; /* Adjust font size as needed */\n}\n\ninput[type=\"text\"] {\n    /* -webkit-appearance: none; Remove default appearance */\n    /* appearance: none; */\n    padding: 8px; /* Adjust padding as needed */\n    font-size: 16px; /* Adjust font size as needed */\n}\n\ninput[type=\"number\"] {\n    /* -webkit-appearance: none; Remove default appearance */\n    /* appearance: none; */\n    padding: 8px; /* Adjust padding as needed */\n    font-size: 16px; /* Adjust font size as needed */\n}\n\n.placeholder{\n    padding: 8px; /* Adjust padding as needed */\n    font-size: 16px; /* Adjust font size as needed */\n}\n/* .dateinput::placeholder{\n    color:'red'\n} */\n\ninput:focus {\n    outline:1px solid #007bff; /* Remove default outline */\n    border-color: #00bfff; /* Change the border color on focus */\n    /* Add any additional styles you want for the focused state */\n}\n\n.descriptionInput{\n    padding: 8px; /* Adjust padding as needed */\n    font-size: 16px; /* Adjust font size as needed */\n}\n\n.descriptionInput:focus{\n    outline:1px solid #007bff; /* Remove default outline */\n    border-color: #00bfff; /* Change the border color on focus */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
